
// import analytics from '@react-native-firebase/analytics';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { merge } from 'lodash';
import { PURGE } from "redux-persist";
import { api } from './api';
import { AuthResult, User } from './types';
import dayjs from 'dayjs';

const __DEV__ = process.env.NODE_ENV === "development"

const initialState: AuthResult & { profile?: User | null } = {
  token: null,
  refreshToken: null,
  id: null,
  profile: null,
  qrCode: null,
  qrCodeSetAt: null,

}
// const analytics: {[key:string]:any} = {}
export const logout = createAction<void>('logout')

const setAnalyctsUserInfo = async (user?: User) => {

  if (user) {
    const analyticsUserProperties = {
      fullName: user?.fullName,
      activityLevelName: user?.activityLevel?.name || null,
      fitnessLevelName: user?.fitnessLevel?.name || null,
      workoutGoalName: user?.workoutGoal?.name || null,
    }
    __DEV__ && console.log('analyticsUserProperties', analyticsUserProperties)
    // await analytics().setUserProperties(analyticsUserProperties)
  }
}
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload
    },
    setRefreshToken(state, action: PayloadAction<string>) {
      state.refreshToken = action.payload
    },
    setAuthData(state, action: PayloadAction<AuthResult>) {
      state.token = action.payload.token
      state.refreshToken = action.payload.refreshToken
      state.id = action.payload.id
    },
  },
  extraReducers: (builder) => {

    builder
      .addCase(logout, (state) => {
        __DEV__ && console.log('logout', state)
        merge(state, {}, initialState)
      })
      .addCase(PURGE, (state, action) => {
        __DEV__ && console.log('PURGE auth from  ', state, ' to ', initialState, 'action', action)
        state.token = undefined
        state.refreshToken = undefined
        state.id = undefined
      })
      .addMatcher(api.endpoints.signIn.matchFulfilled, (state, action) => {
        __DEV__ && console.log('ConnectedUser', action.payload)
        state.token = action.payload.token;
        state.refreshToken = action.payload.refreshToken || action.payload.refresh_token;
        state.id = action.payload.id;
      })
      .addMatcher(api.endpoints.confirmRegistration.matchFulfilled, (state, action) => {
        __DEV__ && console.log('ConnectedUser', action.payload)
        state.token = action.payload.token;
      })
      .addMatcher(api.endpoints.resettingResetPassword.matchFulfilled, (state, action) => {
        __DEV__ && console.log('ConnectedUser', action.payload)
        state.token = action.payload.token;
      })
      // .addMatcher(api.endpoints.register.matchFulfilled, (state, action) => {
      //   __DEV__ && console.log('ConnectedUser', action.payload)
      //   state.token = action.payload.token;
      //   state.refreshToken = action.payload.refreshToken || action.payload.refresh_token;
      //   state.id = action.payload.id;
      // })
      .addMatcher(api.endpoints.checkKioskQrCodeAvailability.matchFulfilled, (state, action) => {
        state.qrCode = action.meta.arg.originalArgs;
        state.token = action.payload.token;
        state.qrCodeSetAt = dayjs().toISOString();

      })
      .addMatcher(api.endpoints.checkKioskQrCodeAvailability.matchRejected, (state, action) => {
        state.qrCode = undefined;
        state.token = undefined;
        state.qrCodeSetAt = undefined;
      })
      .addMatcher(api.endpoints.profile.matchFulfilled, (state, action) => {
        __DEV__ && console.log('profile', action.payload)
        state.profile = action.payload;
        setAnalyctsUserInfo(action.payload)
      })
      ;
  }
})


// Action creators are generated for each case reducer function
export const { setToken, setRefreshToken, setAuthData, } = authSlice.actions

export default authSlice.reducer